import Phaser from 'phaser'
import { LAYER_OBJECTS } from '../layers'

export default class Cone extends Phaser.GameObjects.Image {
  constructor (scene, x, y) {
    super(scene, x, y, 'environ', 'cone_straight')
    this.setOrigin(0.5)
    this.setScale(0.8)
    this.setRotation(-Math.PI + Math.PI / 4 + (scene.rnd.frac() * Math.PI / 2)) // Random rotation upwards
    this.setDepth(LAYER_OBJECTS)
    this.isHit = false
  }

  initialize () {
    this.body.setSize(this.displayWidth * 0.9, this.displayHeight * 0.9)
  }

  isDown () {
    return this.isHit
  }

  onCollision (car, isPlayer) {
    if (this.isHit || !isPlayer) {
      return
    }
    this.isHit = true
    this.setFrame('cone_down')

    const rnd = this.scene.rnd
    this.body.velocity.x = rnd.realInRange(150, 200)
    this.body.velocity.y += car.body.velocity.y / 2
    this.body.angularVelocity = rnd.realInRange(800, 1200)
    this.body.setDrag(195)
    this.body.setAngularDrag(800)

    if (car.body.velocity.x < 0) {
      this.body.velocity.x *= -1
      this.body.angularVelocity *= -1
    }
  }
}
